// CR-0074: sessions-R02/R19/R21; backend-contracts-access-and-auth-api-R03/R04.
import { createAuthUserId, type TAuthUserId } from '../types/auth';
import { httpClient, authEndpoint, redirectToAuth } from './client';
import { assertObject, assertString, assertEntityId, assertArrayOf } from '../types/validation';
export interface IAuthUser {
  readonly id: TAuthUserId;
  readonly login: string;
  readonly fullName: string;
}
export const authApi = {
  startLogin(returnTo: string = '/'): void { redirectToAuth(returnTo); },
  async getCurrentUser(): Promise<IAuthUser> {
    const { data } = await httpClient.get<unknown>('/auth/me');
    const obj = assertObject(data, 'profile');
    return { id: createAuthUserId(assertEntityId(obj['id'], 'profile.id')), login: assertString(obj['login'], 'profile.login'), fullName: assertString(obj['fullName'], 'profile.fullName') };
  },
  async getPermissions(): Promise<string[]> {
    const { data } = await httpClient.get<unknown>('/auth/permissions');
    const obj = assertObject(data, 'permissions');
    return assertArrayOf(obj['privileges'], assertString, 'permissions.privileges');
  },
  // Top-level POST follows the backend's 303 to auth; an XHR redirect cannot
  // perform the common browser logout reliably across product origins.
  logout(): void {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = authEndpoint('/auth/logout');
    document.body.append(form);
    form.submit();
    form.remove();
  },
};

// Temporary compatibility projection for existing domain UI; Code 2 replaces
// shell consumers with the string catalogue. No edit grant implies view.
export function permissionMask(codes: readonly string[]): number {
  const bits: Readonly<Record<string, number>> = {
    'metabridge.projects.view': 1, 'metabridge.projects.edit': 2,
    'metabridge.sources.view': 16, 'metabridge.sources.edit': 32 | 64 | 128,
    'metabridge.sources.run': 256, 'metabridge.exploration.view': 512,
    'metabridge.exploration.edit': 1024, 'metabridge.project_dictionaries.manage': 2048,
    'metabridge.model.view': 4096, 'metabridge.model.edit': 8192,
    'metabridge.mappings.view': 16384, 'metabridge.mappings.edit': 32768,
    'metabridge.versions.view': 65536, 'metabridge.versions.edit': 131072,
    'metabridge.datamarts.view': 262144, 'metabridge.datamarts.edit': 524288,
    'metabridge.comments.view': 1048576, 'metabridge.comments.create': 2097152,
    'metabridge.comments.edit_others': 4194304,
    'metabridge.mdm.edit': 8388608, 'metabridge.databridge.edit': 16777216,
  };
  return codes.reduce((mask, code) => mask | (bits[code] ?? 0), 0);
}
